// auth.service.ts
import{AuthService as Auth0Service, User} from '@auth0/auth0-angular'
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

    public isLoggedInValue = false;
    public accesstoken!: Observable<string>;
    public user$: Observable<User | null | undefined>;
    public userObject: User | null = null;

  constructor(private http: HttpClient, private auth: Auth0Service)
  {
    this.user$ = this.auth.user$;
    this.accesstoken = this.auth.getAccessTokenSilently(); 

    this.user$.subscribe({
      next: (userValue) => {
        if (userValue === undefined) {
          return;
        }
        this.userObject = userValue ?? null;
      },
      error: (err) => {
        console.error('Error fetching user:', err);
        this.userObject = null;
      }
    });
  }
  isLoggedIn() {
    return this.isLoggedInValue;
  }
  login() {
    this.auth.loginWithRedirect();
    // Implement your login logic here
  }

  logout() {
    this.auth.logout({
      logoutParams:{
        returnTo:document.location.origin
      }
    });
  }

  getLoggedInUser(): User | null {
    return this.userObject ? { ...this.userObject } : null;
  }
}
